module.exports = __webpack_public_path__ + "img/carrier-400.1257f75f.png";